import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Painel de conteúdo de uma aba. Deve ser filho de `app-tabs`.
 *
 * ```html
 * <app-tab-panel tabId="dados" label="Dados">
 *   <p>Conteúdo da aba</p>
 * </app-tab-panel>
 * ```
 */
@Component({
  selector: 'app-tab-panel',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="active" class="app-tab-panel flex min-h-0 flex-1 flex-col">
      <ng-content></ng-content>
    </div>
  `
})
export class TabPanelComponent {
  @HostBinding('class') hostClass = 'flex flex-1 min-h-0 flex-col';

  @Input() tabId = '';
  @Input() label = '';

  /** Controlado internamente pelo TabsComponent */
  active = false;
}
